<template>
  <div class="setting">
    <div class="area P3">
      <!--设置-->
      <div class="d d_list d_list2">
        <div class="d bar" @click="goBack">
          <a href="javascript:void(0)" class="a_back"><i class="iC i_back"></i></a>
        </div>
      </div>
      <ul class="u u_sz">
        <li v-if="userName">
          <div href="javascript:void(0)">
            <div class="fl">用户名</div>
          </div>
        </li>
        <li v-if="school">
          <div href="javascript:void(0)" class="t_c">
            <div class="fl">学校</div>
            <div class="tr">{{ school }}</div>
          </div>
        </li>
        <li @click="updatePwd">
          <a href="javascript:void(0)">
            <div class="fl">修改密码</div>
            <i class="iC i_jt"></i>
          </a>
        </li>
      </ul>
      <button @click="handler()" class="btn btn_tc">退出登录</button>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, reactive, toRefs, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { logout } from "@/service/user";
import { logoutClear, getLocal } from "@/common/js";
export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      school: "",
      userName: "",
    });
    onMounted(async () => {
      const school = await getLocal("dsj_school");
      if (school) {
        state.school = school;
      }
    });
    const { proxy } = getCurrentInstance();
    const updatePwd = () => {
      router.push({ path: "/updatePasswrod" });
    };
    const handler = async () => {
      proxy.$tipsMessage(
        true,
        1,
        "提示",
        "您确定要退出当前账号吗？",
        async () => {
          const { code } = await logout();
          console.log("data", code);
          if (code === 10000) {
            logoutClear();
            store.commit("info/RESET_AREA");
            store.commit("info/RESET_ROLELIST");
            router.push({ path: "/" });
          }
          proxy.$tipsMessage(false);
        },
        true
      );
    };
    const goBack = () => {
      router.go(-1);
    };
    return {
      ...toRefs(state),
      handler,
      updatePwd,
      goBack,
    };
  },
  components: {},
};
</script>
<style lang="less" scoped>
.u_sz p.fcG {
  text-align: center;
}
.u_sz p {
  display: block;
  overflow: hidden;
}
.tr {
  // color: #999;
  font-size: 0.373rem;
}
.t_c{
  display: flex;
  justify-content: space-between;
  width: 95%;
}
</style>
